"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[52348],{

/***/ 552348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ProductImages": function() { return /* binding */ ProductImages; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _tekface_smart_activation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(560327);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(670894);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92300);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(55930);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7297);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(875547);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(732324);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(888393);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(428247);
/* harmony import */ var constants_smartBanner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(124177);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(534924);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-start;\n  gap: 0.5rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  border: 1px solid\n    ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








const ProductImages = ()=>{
    var ref;
    const { product , frame , inlineBanners  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useProductDetailState */ .W)();
    const { 0: showGallery , 1: setShowGallery  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: activeIndex , 1: setActiveIndex  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const vidRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const images = (product === null || product === void 0 ? void 0 : product.images) || [];
    const videos = (product === null || product === void 0 ? void 0 : product.videos) || [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", _objectSpreadProps(_objectSpread({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_3__/* .getTrackingData */ .O5)({
        isTrackContent: true,
        regionName: "imgProductDetail",
        contentName: "viewImage",
        target: "productImage",
        payload: JSON.stringify({
            sku: product === null || product === void 0 ? void 0 : product.sellerSku,
            screenName: "productDetail",
            index: activeIndex
        })
    })), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                style: {
                    cursor: "pointer",
                    position: "relative",
                    marginBottom: "0.5rem"
                },
                className: "productDetailPreview" // class for pushdy banner
                ,
                children: [
                    frame && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FrameWrapper, {
                        frame: frame
                    }),
                    images || videos ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tekface_smart_activation__WEBPACK_IMPORTED_MODULE_4__/* .BannerInlinePlaceholder */ .Q, {
                                banners: inlineBanners,
                                className: constants_smartBanner__WEBPACK_IMPORTED_MODULE_5__/* .INLINE_BANNER_CLASSNAME.INLINE_PDP_PREVIEW_DESK */ .h.INLINE_PDP_PREVIEW_DESK
                            }),
                            activeIndex < videos.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_6__/* .ProductVideo */ .N, {
                                source: videos[activeIndex].source,
                                videoProps: {
                                    preload: "none",
                                    width: 325,
                                    height: 325,
                                    playsInline: true,
                                    muted: true,
                                    autoPlay: true,
                                    controls: true,
                                    src: videos[activeIndex].url,
                                    onClick: ()=>setShowGallery(true)
                                },
                                youtubeFrameProps: {
                                    width: 325,
                                    height: 325,
                                    autoplay: 1
                                },
                                url: videos[activeIndex].url
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .LazyImage */ .w, _objectSpreadProps(_objectSpread({
                                contain: true
                            }, images[activeIndex - videos.length]), {
                                onClick: ()=>setShowGallery(true),
                                borderRadius: 8,
                                imageWidth: 500
                            }))
                        ]
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrapperSmallImages, {
                children: (ref = [
                    ...videos,
                    ...images
                ]) === null || ref === void 0 ? void 0 : ref.slice(0, 6).map((img, index)=>{
                    if (index < videos.length) {
                        if (img.source === _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_8__/* .SOURCE_VIDEO.SYSTEM */ .Ok.SYSTEM) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_6__/* .ProductVideo */ .N, {
                                source: img.source,
                                url: img.url,
                                videoProps: {
                                    style: {
                                        cursor: "pointer"
                                    },
                                    ref: vidRef,
                                    preload: "none",
                                    width: 50,
                                    height: 45,
                                    playsInline: true,
                                    muted: true,
                                    autoPlay: true,
                                    onPlayingCapture: ()=>{
                                        var ref;
                                        return (ref = vidRef.current) === null || ref === void 0 ? void 0 : ref.pause();
                                    },
                                    onClick: ()=>setShowGallery(true),
                                    onMouseEnter: ()=>!(index === 5 && images.length > 6) && setActiveIndex(index)
                                }
                            }, index);
                        }
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledYoutubeThumbnail, {
                            width: 45,
                            height: 45,
                            isActive: index === activeIndex,
                            youtubeLink: img.url,
                            onClick: ()=>setShowGallery(true),
                            onMouseEnter: ()=>!(index === 5 && images.length > 6) && setActiveIndex(index)
                        }, index);
                    }
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_9__/* .SmallImage */ .K, {
                        image: img,
                        alt: img.alt,
                        isActive: index === activeIndex,
                        onClick: ()=>setShowGallery(true),
                        onMouseEnter: ()=>!(index === 5 && images.length > 6) && setActiveIndex(index),
                        extra: index === 5 && images.length > 6 ? "+".concat(images.length - 6) : undefined
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Overlay */ .a, {
                show: showGallery,
                onEscPressed: ()=>setShowGallery(false),
                children: images ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_11__/* .Gallery */ .r, {
                    images: images,
                    videos: videos === null || videos === void 0 ? void 0 : videos.map((video)=>{
                        return _objectSpreadProps(_objectSpread({}, video), {
                            src: video.url
                        });
                    }),
                    bgColor: "white",
                    onClose: ()=>setShowGallery(false),
                    activeImageIndex: activeIndex
                }) : null
            })
        ]
    }));
};
const WrapperSmallImages = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__["default"].div(_templateObject());
const FrameWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__["default"].div((param)=>{
    let { frame  } = param;
    return "\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 10;\n  display: flex;\n  flex-wrap: wrap;\n  background-image: url(".concat(frame, ");\n  background-size: cover;\n  height: 100%;\n  width: 100%;\n  cursor: pointer;\n  ");
});
const StyledYoutubeThumbnail = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .YoutubeThumbnail */ .F)(_templateObject1(), (param)=>{
    let { isActive , theme  } = param;
    return isActive ? theme === null || theme === void 0 ? void 0 : theme.colors.primary500 : "transparent";
});


/***/ })

}]);